import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function addContentCardFeedback(requestData, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.post("api/addContentCardFeedback", {
      ...requestData,
      userKey,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
